import React, { useState } from "react";
import { Collapse, Icon } from "antd";
import { CollapseProps } from "antd/es/collapse";
import CoursewareItem from "../CoursewareItem";
import styles from "./index.module.scss";
import { ChapterType, SourceType } from "API/courseware";
import classNames from "classnames";
import { toNumber } from "Utils/filter";

const Panel = Collapse.Panel;

interface ChapterNodeProps extends CollapseProps {
    title: React.ReactNode;
    indent?: number;
    chapters: ChapterType[];
    sources: SourceType[];
}

export default function ChapterNode({
    title,
    chapters,
    sources,
    className,
    indent = 0
}: ChapterNodeProps) {
    const [key] = useState(Math.random());
    const [collapse, setCollapse] = useState<boolean>(false);

    return (
        <Collapse
            className={classNames(className, styles[`indent${indent}`])}
            defaultActiveKey={key}
            expandIcon={() => (
                <Icon
                    type={collapse ? "caret-right" : "caret-down"}
                    style={{ color: "#bbb" }}
                />
            )}
            onChange={keys => setCollapse(keys.length === 0)}>
            <Panel header={title} key={key}>
                {chapters.map(item => (
                    <ChapterNode
                        key={item.id}
                        indent={toNumber(item.level)}
                        title={item.chapterName}
                        chapters={item.children || []}
                        sources={item.dcCoursewareSourceList || []}
                    />
                ))}

                {sources.map(item => (
                    <CoursewareItem key={item.id} data={item} indent={indent} />
                ))}
            </Panel>
        </Collapse>
    );
}
